import apiClient from 'services/axios'
import ApiConfig from 'services/config'
// import errorHandler from 'components/error.handler'

function getAllowanceCardDesign(businessCode) {
  return apiClient
    .get(`${ApiConfig.AllowanceCardDesignConfig.AllowanceCardDesign}${businessCode}`)
    .then(response => response?.data)
}

export default getAllowanceCardDesign
